export var VpcPeeringStatus;
(function (VpcPeeringStatus) {
    VpcPeeringStatus["VPC_PEERING_STATUS_CREATING"] = "CREATING";
    VpcPeeringStatus["VPC_PEERING_STATUS_CREATE_FAILED"] = "CREATE_FAILED";
    VpcPeeringStatus["VPC_PEERING_STATUS_INITIATING_REQUEST"] = "INITIATING_REQUEST";
    VpcPeeringStatus["VPC_PEERING_STATUS_PENDING_ACCEPTANCE"] = "PENDING_ACCEPTANCE";
    VpcPeeringStatus["VPC_PEERING_STATUS_ACTIVE"] = "ACTIVE";
    VpcPeeringStatus["VPC_PEERING_STATUS_DELETING"] = "DELETING";
    VpcPeeringStatus["VPC_PEERING_STATUS_DELETED"] = "DELETED";
    VpcPeeringStatus["VPC_PEERING_STATUS_REJECTED"] = "REJECTED";
    VpcPeeringStatus["VPC_PEERING_STATUS_FAILED"] = "FAILED";
    VpcPeeringStatus["VPC_PEERING_STATUS_EXPIRED"] = "EXPIRED";
    VpcPeeringStatus["VPC_PEERING_STATUS_PROVISIONING"] = "PROVISIONING";
})(VpcPeeringStatus || (VpcPeeringStatus = {}));
